// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event-layout{display:flex;flex-grow:1;min-height:100vh;padding-top:44px}.event-layout:before{height:calc(100% - 44px)}@media(max-width:1023px){.event-layout{height:100%}}body .siq_bR{bottom:50px}body .zsiq_theme1 div.zsiq_cnt{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
